import React from 'react'

interface AmpInterstitialLinkProps {
  href: string
  children: React.ReactNode
  enableInterstitial?: boolean
  style?: React.CSSProperties
  [key: string]: unknown
}

export default function AmpInterstitialLink({
  href,
  children,
  enableInterstitial = true,
  style,
  ...restProps
}: AmpInterstitialLinkProps) {
  if (!enableInterstitial) {
    return (
      <a href={href} style={{ cursor: 'pointer', ...style }} {...restProps}>
        {children}
      </a>
    )
  }

  const escapedHref = href.replace(/'/g, "\\'")

  // store the destination URL in AMP state and open the interstitial lightbox on tap
  return (
    <a
      data-testid="amp-interstitial-link"
      on={`tap:AMP.setState({interstitialState: {destinationUrl: '${escapedHref}'}}),interstitialAdLightbox.open`}
      style={{ cursor: 'pointer', ...style }}
      {...restProps}
    >
      {children}
    </a>
  )
}
